<template lang="pug">

  // is-success(完了)
  b-message(v-if="type === 'success'", type="is-success" title="完了", :closable="false")
    slot

  // is-warning(ご注意)
  b-message(v-else-if="type === 'warning'", type="is-warning" title="ご注意", :closable="false")
    slot

  // is-info
  b-message(v-else-if="type === 'info'", type="is-info")
    slot

  // is-danger(エラー)
  b-message(v-else-if="type === 'danger'", type="is-danger" title="エラー", :closable="false")
    slot

</template>

<script>
export default {
  name: 'AppMessage',
  props: {
    type: {type: String, required: false, default: 'info'} // success, warning, danger
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AppMessage.vue